import styled from 'styled-components'

export const StyledSubNavTabs = styled.div<{ hasTitle: boolean }>`
  display: flex;
  flex-direction: row;
  border-bottom: 2px solid ${props => props.theme.colors.neutral.lighter};

  ${props => props.hasTitle && `margin-bottom: ${props.theme.spacings.medium}`};
`
